import React, { useEffect, useState } from 'react';

const useDragOutsideElement = <T extends HTMLElement>(
  ref: React.RefObject<T>,
  initState?: boolean,
) => {
  const [dragOutside, setDragOutside] = useState<boolean>(!!initState);

  useEffect(() => {
    const handleDrag = (event: DragEvent) => {
      if (ref.current) {
        /* Checks whether the event.target (i.e. where in the document the event was triggered)
         * includes the referenced element (ref) as a child or self
         * */
        setDragOutside(!ref.current.contains(event.target as HTMLElement));
      }
    };

    // Reset dragging when the mouse enters the window/root element
    const handleMouseEnter = () => setDragOutside(true);

    const rootElement = document.documentElement;
    rootElement.addEventListener('dragover', handleDrag);
    rootElement.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      rootElement.removeEventListener('dragover', handleDrag);
      rootElement.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [ref]);

  return dragOutside;
};

export default useDragOutsideElement;
